import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { Dispatch } from 'redux';
import { unbusyAll } from '../actions/commonActions';
import TriggerCRUDActions from '../actions/TriggerCRUDActions';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

export const triggersHandler =
  (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, action?: string) => {
    if (
      !window.MMApp?.throwErrors &&
      error instanceof Response &&
      error.status === UNPROCESSABLE_ENTITY &&
      action === TriggerCRUDActions.updateAction
    ) {
      const responseErrorBody = await getErrorJson(error);
      const errorMessage = responseErrorBody.errors;

      dispatch(
        modalActions.openPrettyErrorModal({
          title: '',
          errorMessage,
        }),
      );
      dispatch(unbusyAll());
      throw errorMessage;
    } else {
      await commonHandler(dispatch)(error);
    }
  };
